import {Agent} from './agent';
import {UserAccount} from './user-account';
import {Partner} from './partner';

export class PaymentParcel {
  id: number;
  date: string;
  type = -100; // AgentDeposit by default
  value: number;
  currency = '€'; // Euro by default
  paymentDirection = 0; // In by default
  TreasurerAgent: Agent;
  TreasurerSupplier: Partner;
  TreasurerUserAccount: UserAccount;
  allocations: { amount: number; change: number; type: number; isAgentPayment: boolean; }[];
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/payment-parcel.ts